import { AfterContentChecked, Component } from '@angular/core';
import { Router } from '@angular/router';

import { SidebarService } from '@core/services/sidebar.service';
import { AuthService } from '@core/auth/auth.service';
import { ClientAccountService } from '@shared/services/client-account.service';
import { UsersService } from '@shared/services/users.service';
import { ApplicationUserModel } from '@shared/models/application-user.model';
import { UserPrimaryRoleConstants } from '@shared/constants/roles.constants';
import { ModalService } from '@shared/services/modal.service';

declare var $: any;

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements AfterContentChecked {
  user: ApplicationUserModel;
  users: Array<ApplicationUserModel>;
  UserPrimaryRoleConstants = UserPrimaryRoleConstants;
  secondaryRoles: string[];
  activeExternalBadge: boolean;
  countExternal: number = 0;

  constructor(public router: Router, public clientAccountService: ClientAccountService, private authService: AuthService, public usersService: UsersService, public sidebarService: SidebarService, public modalService: ModalService) {
    this.user = this.usersService.getUser() as ApplicationUserModel;
    this.usersService.getUsers().subscribe((res: Array<ApplicationUserModel>) => {
      this.users = res;
      for (let u of this.users) {
        if (u.external) {
          this.activeExternalBadge = true;
          this.countExternal = this.countExternal + u.roles.length;
        }
      }
    });
    this.manageUsersRoles();
    if (!this.usersService.activeRole) {
      this.usersService.setDefaultRole();
    }
  }

  manageUsersRoles() {
    this.secondaryRoles = this.user?.aggregations[0].roles.map(r => r.id).filter(r => r !== UserPrimaryRoleConstants.OPV && r !== UserPrimaryRoleConstants.ORS && r !== UserPrimaryRoleConstants.OCC);

  }

  ngAfterContentChecked(): void {
    setTimeout(() => {
      $('#rolesInfo').popover({
        html: true,
        content: () => {
          return this.user.roles.length > 0 ? $('.popover-body-roles').html() : 'Nessuna ruolo presente';
        }
      });
      $('#externalInfo').popover({
        html: true,
        content: () => {
          return $('.popover-body-external-roles').html();
        }
      });
    }, 8);
  }

  changeClienteAccount() {
    this.clientAccountService.changeClienteAccount();
  }

  logout() {
    this.authService.logout();
  }

  changeUser() {
    this.usersService.changeUser();
  }

  managePassword() {
    this.modalService.open('manage-password-modal');
  }
}
